const { formatText } = require('core/i18n').i18n;
// <formatText value="avatarPicker-createImage" />

function AvatarEditorTranslations () {
    return  {
    title_placeholder_man: formatText('avatarEditor-placeholder_man'),
    title_placeholder_woman: formatText('avatarEditor-placeholder_woman'),
    welcome_msg_1: formatText('avatarEditor-welcome_msg_1'),
    welcome_msg_2: formatText("avatarEditor-welcome_msg_2"),
    cancel_button: formatText("avatarEditor-cancel_button"),
    accept_button: formatText("avatarEditor-accept_button"),
    wait_msg: formatText("avatarEditor-wait_msg"),
    rnd_msg: formatText("avatarEditor-rnd_msg"),
    reset_msg: formatText("avatarEditor-reset_msg"),
    save_msg: formatText("avatarEditor-save_msg"),
    share_msg: formatText("avatarEditor-share_msg"),
    gravatar_msg: formatText("avatarEditor-gravatar_msg"),
    dnl_msg: formatText("avatarEditor-dnl_msg"),
    svg_msg: formatText("avatarEditor-svg_msg"),
	confirm_msg_title: formatText("avatarEditor-confirm_msg_title"),
	confirm_msg_text: formatText("avatarEditor-confirm_msg_text"),
    ios_msg: formatText("avatarEditor-ios_msg"),
	gravatar_title_title: formatText("avatarEditor-gravatar_title_title"),
	gravatar_title_text: formatText("avatarEditor-gravatar_title_text"),
    gravatar_email: formatText("avatarEditor-gravatar_email"),
    gravatar_pwd: formatText("avatarEditor-gravatar_pwd"),
    gravatar_rating: formatText("avatarEditor-gravatar_rating"),
    gravatar_note: formatText("avatarEditor-gravatar_note"),
    install_msg: formatText("avatarEditor-install_msg"),
    alert_svg_support_error_1: formatText("avatarEditor-alert_svg_support_error_1"),
    alert_svg_support_error_2: formatText("avatarEditor-alert_svg_support_error_2"),
    alert_json_error_title: formatText("avatarEditor-alert_json_error_title"),
	alert_json_error_text: formatText("avatarEditor-alert_json_error_text" ),
	alert_success_title: formatText("avatarEditor-alert_success_title"),
	alert_success_text: formatText("avatarEditor-alert_success_text"),
	alert_error_title: formatText("avatarEditor-alert_error_title"),
	alert_error_text: formatText("avatarEditor-alert_error_text"),
	alert_error_download_title:  formatText("avatarEditor-alert_error_download_title"),
	alert_error_download_text: formatText("avatarEditor-alert_error_text"),
	alert_error_image_title: formatText("avatarEditor-alert_error_text"),
    alert_success_gravatar_title: formatText("avatarEditor-alert_success_gravatar_title"),
	alert_success_gravatar_text1: formatText("avatarEditor-alert_success_gravatar_text1"),
    alert_success_gravatar_text2: formatText("avatarEditor-alert_success_gravatar_text2"),
	alert_common_error_gravatar_title: formatText("avatarEditor-alert_common_error_gravatar_title"),
	alert_common_error_gravatar_text: formatText("avatarEditor-alert_error_text"),
    alert_error_ratingfail_title: formatText("avatarEditor-alert_error_ratingfail_title"),
	alert_error_ratingfail_text: formatText("avatarEditor-alert_error_ratingfail_text" ),
	alert_error_emailfail_title: formatText("avatarEditor-alert_error_emailfail_title"),
	alert_error_emailfail_text: formatText("avatarEditor-alert_error_emailfail_text"),
	alert_error_passwordfail_title: formatText("avatarEditor-alert_error_passwordfail_title"),
	alert_error_passwordfail_text: formatText("avatarEditor-alert_error_passwordfail_text"),
	alert_error_imagefail_title: formatText("avatarEditor-alert_error_imagefail_title"),
	alert_error_imagefail_text: formatText("avatarEditor-alert_error_text"),
	alert_error_faultcode_8_title: formatText("avatarEditor-alert_error_faultcode_8_title"),
	alert_error_faultcode_8_text: formatText("avatarEditor-alert_error_faultcode_8_text"),
	alert_error_faultcode_9_title: formatText("avatarEditor-alert_error_faultcode_9_title"),
	alert_error_faultcode_9_text: formatText("avatarEditor-alert_error_faultcode_9_text"),
    crd_msg: formatText("avatarEditor-crd_msg"),
    ok_msg: formatText("avatarEditor-ok_msg"),
    cancel_msg: formatText("avatarEditor-cancel_msg"),
    close_msg: formatText("avatarEditor-close_msg"),
    tryagain_msg: formatText("avatarEditor-tryagain_msg"),
    block_titles: {
        face: formatText("avatarEditor-block_face"),
        eyes: formatText("avatarEditor-block_eyes"),
        hair: formatText("avatarEditor-block_hair"),
        clothes: formatText("avatarEditor-block_clothes"),
        backs: formatText("avatarEditor-block_backs"),
    },
    body_zone_titles: {
        backs: formatText("avatarEditor-body_backs"),
        faceshape: formatText("avatarEditor-body_faceshape"),
        chinshadow:'',//not displayed, just for compatibility
        facehighlight:'',//not displayed, just for compatibility
        humanbody:'',//not displayed, just for compatibility
        clothes: formatText("avatarEditor-body_clothes"),
        hair: formatText("avatarEditor-body_hair"),
        ears: formatText("avatarEditor-body_ears"),
        eyebrows: formatText("avatarEditor-body_eyebrows"),
        eyesback:'',//not displayed, just for compatibility
        eyesiris: formatText("avatarEditor-body_eyesiris"),
        eyesfront: formatText("avatarEditor-body_eyesfront"),
        mouth: formatText("avatarEditor-body_mouth"),
        nose: formatText("avatarEditor-body_nose"),
        glasses: formatText("avatarEditor-body_glasses"),
        mustache: formatText("avatarEditor-body_mustache"),
        beard: formatText("avatarEditor-body_beard"),
    }
    };
}

//module.exports = avatarEditorTranslations;
export default AvatarEditorTranslations;
